<template>
  <div class="top-section-logos">
    <swiper
      :options="swiperOption"
      class="top-section-logos-wrap"
    >
      <swiper-slide>
        <walmart-icon class="walmart-icon"/>
      </swiper-slide>
      <swiper-slide>
        <target-icon class="target-icon"/>
      </swiper-slide>
      <swiper-slide>
        <tesco-icon class="tesco-icon"/>
      </swiper-slide>
      <swiper-slide>
        <qvc-icon class="qvc-icon"/>
      </swiper-slide>
      <swiper-slide>
        <hasbro-icon class="hasbro-icon"/>
      </swiper-slide>
      <swiper-slide>
        <mattel-icon class="mattel-icon"/>
      </swiper-slide>
      <swiper-slide>
        <bbb-icon class="bbb-icon"/>
      </swiper-slide>
      <swiper-slide>
        <williams-sonoma-icon class="williams-sonoma-icon"/>
      </swiper-slide>
      <swiper-slide>
        <bloomingdales-icon class="bloomingdales-icon"/>
      </swiper-slide>
      <swiper-slide>
        <argos-icon class="argos-icon"/>
      </swiper-slide>
      <swiper-slide>
        <sur-la-table-icon class="sur-la-table-icon"/>
      </swiper-slide>
      <swiper-slide>
        <sainsburys-icon class="sainsburys-icon"/>
      </swiper-slide>
      <swiper-slide>
        <lidl-icon class="lidl-icon"/>
      </swiper-slide>
      <swiper-slide>
        <h-s-n-icon class="h-s-n-icon"/>
      </swiper-slide>
      <swiper-slide>
        <canadian-tire-icon class="canadian-tire"/>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import WalmartIcon from 'static/assets/icons/WalmartIcon.svg'
import TargetIcon from 'static/assets/icons/TargetIcon.svg'
import QvcIcon from 'static/assets/icons/QvcIcon.svg'
import MattelIcon from 'static/assets/icons/MattelIcon.svg'
import BbbIcon from 'static/assets/icons/BBBIcon.svg'
import TescoIcon from 'static/assets/icons/TescoIcon.svg'
import WilliamsSonomaIcon from 'static/assets/icons/WilliamsSonomaIcon.svg'
import BloomingdalesIcon from 'static/assets/icons/BloomingdalesIcon.svg'
import ArgosIcon from 'static/assets/icons/ArgosIcon.svg'
import SurLaTableIcon from 'static/assets/icons/SurLaTableIcon.svg'
import SainsburysIcon from 'static/assets/icons/SainsburysIcon.svg'
import LidlIcon from 'static/assets/icons/LidlIcon.svg'
import HSNIcon from 'static/assets/icons/HSNIcon.svg'
import CanadianTireIcon from 'static/assets/icons/CanadianTireIcon.svg'
import HasbroIcon from 'static/assets/icons/HasbroIcon.svg'

export default {
  name: 'TopSectionLogos',
  components: {
    WalmartIcon,
    TargetIcon,
    QvcIcon,
    MattelIcon,
    BbbIcon,
    swiper,
    swiperSlide,
    TescoIcon,
    WilliamsSonomaIcon,
    BloomingdalesIcon,
    ArgosIcon,
    SurLaTableIcon,
    SainsburysIcon,
    LidlIcon,
    HSNIcon,
    CanadianTireIcon,
    HasbroIcon,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 5,
        spaceBetween: 0,
        autoplay: true,
        breakpoints: {
          640: {
            slidesPerView: 3,
          }
        }
      }
    }
  },
}
</script>

<style lang="sass">
@import '~styles/shared'

.top-section-logos
  display: flex
  justify-content: space-between
  align-items: center
  border-top: 1px solid #eaeaea
  border-bottom: 1px solid #eaeaea
  padding: 30px 13px 30px 23px
  height: 139px
  box-sizing: border-box

  @include tablet
    padding-left: 27px
    padding-right: 15px

  @include largedesktop
    padding-left: 130px
    padding-right: 150px

  svg
    position: relative
    width: 83px

    @include tablet
      width: 151px

    &.walmart-icon
      // left: 16px

      @include tablet
        top: 2px
        left: 1px
        height: 24px

      @include desktop
        height: auto

      @include largedesktop
        left: 4px

    &.qvc-icon
      width: 35px
      top: 4px

      @include tablet
        width: 62px
        height: 40px
        top: 5px
        left: 20px

      @include desktop
        height: auto

      @include largedesktop
        left: 0

    &.target-icon
      left: 5px

      @include tablet
        left: 0
        top: 3px
        height: 21px

      @include desktop
        top: 4px
        height: auto

    &.hasbro-icon
      width: 45px
      top: 1px

      @include tablet
        width: 48px
        left: 11px
        top: 5px

      @include desktop
        width: 70px

    &.mattel-icon
      width: 43px

      @include tablet
        width: 68px
        left: 8px
        top: 4px
        height: 46px

      @include desktop
        height: auto

    &.bbb-icon
      width: 67px

      @include tablet
        width: 127px
        top: 3px
        height: 33px

      @include desktop
        height: auto

      @include largedesktop
        left: 8px

    &.bloomingdales-icon
      width: 100px

      @include tablet
        width: 200px
        height: 20px
        left: -13px
        top: 4px

      @include desktop
        left: 10px
        height: 29px

    &.argos-icon
      width: 70px
      top: 3px

      @include tablet
        top: 5px
        left: 10px
        width: 100px
        height: 34px

      @include desktop
        height: 46px

    &.sur-la-table-icon
      @include tablet
        height: 21px
        right: 3px

      @include desktop
        height: 31px

    &.sainsburys-icon
      @include tablet
        height: 21px
        left: 9px

      @include desktop
        height: 31px

    &.tesco-icon
      left: 5px
      top: 5px

      @include tablet
        top: 4px
        height: 22px

      @include desktop
        top: 5px
        height: 32px

    &.williams-sonoma-icon
      width: 80px
      top: 5px
      left: -5px

      @include tablet
        width: 120px
        height: 40px
        top: 5px
        left: 11px

      @include desktop
        top: 8px
        height: 50px
        right: 3px
        left: 0

    &.lidl-icon
      width: 50px

      @include tablet
        width: 60px
        height: 42px
        left: 21px

      @include desktop
        left: 3px
        height: 63px

    &.h-s-n-icon
      width: 50px

      @include tablet
        width: 60px
        height: 63px
        left: 5px
        height: 42px

      @include desktop
        height: 63px

    &.canadian-tire
      width: 65px
      top: -4px

      @include tablet
        width: 80px
        height: 48px
        left: -7px

      @include desktop
        left: 5px
        height: 63px

.top-section-logos-wrap
  max-width: 1150px
  margin: 0 auto
  z-index: 10
  position: relative

.swiper-wrapper
  align-items: center

.swiper-slide
  text-align: center
</style>



// WEBPACK FOOTER //
// src/TopSectionLogos.vue